import AirClone from "../assets/snipcode/airbnb-clone.png";
import ModBank from "../assets/snipcode/modern-bank.png";
import GalaxyTravels from "../assets/snipcode/galaxy-travels.png";
import AptiveData from "../assets/snipcode/aptive-data.png";
import Drawing from "../assets/snipcode/drawing-app.png";
import Webull from "../assets/snipcode/react-styled-webull.png";
import Datasite from "../assets/snipcode/datasite.png";
import FirstResponsive from "../assets/snipcode/responsive-portfolio.png";
import FoodPanda from "../assets/snipcode/food-panda.png";
import Drive from "../assets/snipcode/drive-rental.png";
import FoodStore from "../assets/snipcode/best-eats.png"
import Beaches from "../assets/snipcode/beacher-tailwind.png"
import ApiAxios from "../assets/snipcode/api-axios.png";
import Time from '../assets/snipcode/api-weather-time.png'
import JS30 from '../assets/snipcode/JS30.PNG'
import Type from '../assets/snipcode/type.png'

export const data=[
    {
        id:1,
        name:"TodoList",
        image:Type,
        github:"https://github.com/HassanShanJava/react-typescript-todolist",
        live:"https://reacttypescript-todolist.netlify.app/",
    },
    {
        id:2,
        name:"Airbnb Landing Clone",
        image:AirClone,
        github:"https://github.com/HassanShanJava/airbnb-landing-clone",
        live:"https://airbnb-landing-clone-page.netlify.app/",
    },
    {
        id:3,
        name:"Time Application",
        image:Time,
        github:'https://github.com/HassanShanJava/Api-Axios-Quotes',
        live:'https://api-weather-time.netlify.app/',
    },
    {
        id:4,
        name:"Galaxy Travels Application",
        image:GalaxyTravels,
        github:"https://github.com/HassanShanJava/galaxy-travels-router",
        live:"https://galaxy-travel-page.netlify.app/",
    },
    {
        id:5,
        name:"Modern Banking Appilcation",
        image:ModBank,
        github:"https://github.com/HassanShanJava/modern-banking-app",
        live:"https://hs-modern-bank-app.netlify.app/",
    },
    {
        id:6,
        name:"Aptive Data Application",
        image:AptiveData,
        github:"https://github.com/HassanShanJava/Aptive-Router",
        live:"https://aptive-data-commerce.netlify.app/",
    },
    {
        id:7,
        name:"Data Site Application",
        image:Datasite,
        github:"https://github.com/HassanShanJava/DataSite-Tail",
        live:"https://datasite-rt.netlify.app/",
    },
    {
        id:8,
        name:"Drawing Application",
        image:Drawing,
        github:"https://github.com/HassanShanJava/drawing-app",
        live:"https://drawing-app-2.netlify.app/",
    },
    {
        id:9,
        name:"First Responsive Website",
        image:FirstResponsive,
        github:"https://github.com/HassanShanJava/my-project-portfolio",
        live:"https://hassan-shan-portfolio.netlify.app/",
    },
    {
        id:10,
        name:"Webull Stocks Application",
        image:Webull,
        github:"https://github.com/HassanShanJava/react_styled_components_gh",
        live:"https://hassanshanjava.github.io/react_styled_components_gh/",
    },
    {
        id:11,
        name:"FoodPanda Landing Page Clone",
        image:FoodPanda,
        github:"https://github.com/HassanShanJava/FoodPanda-Clone-Landing-Page",
        live:"https://foodpanda-clone.netlify.app/",
    },
    {
        id:12,
        name:"Drive Cars Rental Application",
        image:Drive,
        github:"https://github.com/HassanShanJava/drive-cars-landing-page",
        live:"https://drive-rent-a-car.netlify.app/",
    },
    {
        id:13,
        name:"Best Eats Application",
        image:FoodStore,
        github:"https://github.com/HassanShanJava/food-store",
        live:"https://best-eats-foodstore.netlify.app/",
    },
    {
        id:14,
        name:"Beaches Travel Site",
        image:Beaches,
        github:"https://github.com/HassanShanJava/react-tailwinds-video",
        live:"https://beaches-tailwind.netlify.app/",
    },
    {
        id:15,
        name: 'API Axios Application',
        image:ApiAxios,
        github:"https://github.com/HassanShanJava/react-tailwinds-api",
        live:"https://api-axios-react.netlify.app/",
    },
    {
        id:16,
        name: 'JavaScript 30 Days Challenge ',
        image:JS30,
        github:"https://github.com/HassanShanJava/JavaScript30-Journey",
        live:"https://javascript30-hassan.netlify.app/",
    }

]